import { useEffect } from 'react';
import { createTableColumn as createCustomFieldColumn } from 'services/customFieldsV2';

export const useUpdateCustomFields = ({ customFields, selectedColumns, setSelectedColumns }) => {
  useEffect(() => {
    if (!customFields?.length) return;

    let result = [...selectedColumns];

    // Step 1: Delete missing objects
    result = result.filter(
      (item) => !item.customField || customFields.some((field) => field.id === item.customField.id),
    );

    // Step 2: Update existing objects
    result.forEach((secondItem) => {
      const firstItem = customFields.find((field) => field.id === secondItem.customField?.id);
      if (firstItem) {
        Object.assign(secondItem, {
          customField: { ...firstItem },
          Header: firstItem.name,
          cellRenderer:
            firstItem.type === 'single_select' ? 'customFieldSingleSelectRenderer' : 'customFieldTextRenderer',
        });
      }
    });

    // Step 3: Add new objects
    customFields.forEach((firstItem) => {
      if (!result.some((secondItem) => secondItem.customField?.id === firstItem.id)) {
        const newEntry = createCustomFieldColumn(firstItem);
        result.push(newEntry);
      }
    });
    setSelectedColumns(result);
  }, [customFields]); // eslint-disable-line react-hooks/exhaustive-deps
};
